import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'overlay-empty-data',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './overlay-empty-data.component.html',
  styleUrls: ['./overlay-empty-data.component.scss']
})
export class OverlayEmptyDataComponent {

  @Input({required: true}) showOverlay!: boolean;
  @Input() MainText?: string;
  @Input() SubText?: string;
  @Input() withEmptyImage?: boolean;
  @Input() withIcon?: boolean;
  @Input() iconClass?: string;
  @Input() mainTextClass?: string;

  constructor(){
    this.SubText = "No data available";
    this.withEmptyImage = false;
  }

}
